import type { Profile, ProfileRequest } from "@shyne/shared/api";
import { api } from "@/lib/api";
import { contentTypeOf, putPhoto } from "@/lib/appointment-photos";

export const UsersRepository = {
    async getCurrentUser(): Promise<Profile> {
        return api.profile.get();
    },

    async updateCurrentUser(changes: ProfileRequest): Promise<Profile> {
        return api.profile.save(changes);
    },

    async uploadUserAvatar(file: File): Promise<Profile> {
        const contentType = contentTypeOf(file);
        const upload = await api.profile.avatarUpload({ contentType });
        await putPhoto(upload, file, contentType);
        return api.profile.setAvatar({ avatarUrl: upload.photoUrl });
    },
}
